// represents the following features that can be added to particular lens:
// Bevel, Edge, Tint Color, TintType

export class LensFeature {

  constructor (public labServiceId: string, public description: string, public catalogApiEnum: string) {
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/data/lens-feature.ts